import React from 'react';

import {
    Modal,
    Form,
    Button,
    message,
    Input,
} from 'antd'

import {
    _postAddVm,
    _postEditVm
} from '../../services'

import EnterpriseSelector from './enterprise-selector'

import './index.css';

class NewVmModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            enterpriseSelected: false
        }
    }

    render() {
        return (
            <Modal
                title="New VM"
                visible={this.props.newVmModalVisible}
                onCancel={() => this.props.closeVmModal()}
                footer={false}
            >
                {this.renderForm()}
            </Modal>
        )
    }

    componentDidMount() {
        if (this.props.vmData) {
            this.setState({
                enterpriseSelected: this.props.vmData.enterpriseId ? this.props.vmData.enterpriseId : false
            })
        }
    }

    renderForm = () => {

        const { getFieldDecorator } = this.props.form;
        const { vmData } = this.props
        
        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };

        const tailLayout = {
            wrapperCol: { offset: 10, span: 4 },
        };

        return (
            <Form 
            {...layout}
            onSubmit={this.handleSubmit}>

                <Form.Item label="Name">
                    {getFieldDecorator('name', {
                        initialValue: vmData ? vmData.name : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Name of VM" id="name" />
                    )}
                </Form.Item>

                <p classname='section-title'>VM Address</p>

                <Form.Item label="Address">
                    {getFieldDecorator('address', {
                        initialValue: vmData ? vmData.address.address : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Address" id="address" />
                    )}
                </Form.Item>
                <Form.Item label="Building">
                    {getFieldDecorator('building', {
                        initialValue: vmData ? vmData.address.building : '',
                    })(
                        <Input placeholder="Building" id="building" />
                    )}
                </Form.Item>
                <Form.Item label="Unit">
                    {getFieldDecorator('unit', {
                        initialValue: vmData ? vmData.address.unit : '',
                    })(
                        <Input placeholder="Unit" id="unit" />
                    )}
                </Form.Item>
                <Form.Item label="Postal Code">
                    {getFieldDecorator('postalCode', {
                        initialValue: vmData ? vmData.address.postalCode : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Postal Code" id="postalCode" />
                    )}
                </Form.Item>
                <Form.Item label="Country">
                    {getFieldDecorator('country', {
                        initialValue: vmData ? vmData.address.country : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Country" id="country" />
                    )}
                </Form.Item>

                <p classname='section-title'>Enterprise</p>

                {this.state.enterpriseSelected ? 

                    <div>

                        <Form.Item label="Enterprise Selected">
                            {getFieldDecorator('companyName', {
                                initialValue: '',
                            })(
                                <p>{this.state.companyName}</p>
                            )}
                        </Form.Item>

                        <Form.Item label="Dep Codes">
                            {getFieldDecorator('departmentCode', {
                                initialValue: '',
                                rules: [{ required: true }],
                            })(
                                <Input placeholder="Department Code" id="departmentCode" />
                            )}
                        </Form.Item>

                        <Button onClick={() => this.setState({enterpriseSelected: false})}>Remove Enterprise</Button>
                    </div>

                    :
                
                    <Form.Item label="Enterprise">
                        {getFieldDecorator('enterprise', {
                            initialValue: '',
                        })(
                            <EnterpriseSelector
                                onSelect={this.handleEnterpriseSelected}
                            />
                        )}
                    </Form.Item>

                }

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        )
    }

    handleEnterpriseSelected = (value) => {

        const [enterpriseId, companyName] = value.split('~!@')

        this.setState({
            enterpriseSelected: enterpriseId,
            companyName,
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
          if (!err) {
            var { name, address, building, unit, postalCode, country, departmentCode } = values
            const { enterpriseSelected } = this.state;
            const { vmData } = this.props;

            address = {
                address,
                building,
                unit,
                postalCode,
                country
            }

            // If vmData exists, means its an edit
            if (vmData) {
                _postEditVm({
                    vmId: vmData._id, 
                    name, 
                    address, 
                    enterpriseId: enterpriseSelected, 
                    departmentCode
                })
                .then(_newVm => {
                    message.success('Edit success!')
                    this.props.closeVmModal()
                })
            } else {
                _postAddVm({
                    name,
                    address, 
                    enterpriseId: enterpriseSelected, 
                    departmentCode 
                })
                .then(_newVm => {
                    message.success('Add success!')
                    this.props.closeVmModal()
                })
                
            }

          
          }

        })

    }

}

export default Form.create()(NewVmModal)


// WEBPACK FOOTER //
// ./src/components/vm/modal.js